import "../PageCommon.css";
import "./OptimisationAndSensitivity.css";

const OptimisationAndSensitivityPage = () => {
  return (
    <div className="page__container">
      <div className="page__head">
      </div>
      <div className="page__body">
        <div className="page__label">
          <h2>Optimisation And Sensitivity</h2>
        </div>
      </div>
    </div>
  );
}

export default OptimisationAndSensitivityPage;